<script>
import TTabContainer from "@/components/Tabbed/TTabContainer.vue";
import VTabContainer from "@/components/Vertical/VTabContainer.vue";
import HTabContainer from "@/components/Horizontal/HTabContainer.vue";
import SidebarContainer from "./components/Sidebar/SidebarContainer.vue";
import ModalContainer from "./components/Modal/ModalContainer.vue";
import ChatContainer from "./components/Chat/ChatContainer.vue";
import MascotContainer from "./components/Mascot/MascotContainer.vue";

import ScreenContainer from "./components/FullScreen/FullScreenContainer.vue";
import CELContainer from "./components/CELChat/CELContainer.vue";

import OHLAContainer from "./components/OHLA/OHLAContainer.vue";

import ConexusContainer from "./components/Conexus/ConexusContainer.vue";

import DirastiContainer from "./components/Dirasti/DirastiContainer.vue";

import AlterContainer from "./components/AlterECS/AlterContainer.vue";

import ILACContainer from "./components/ILAC/ILACContainer.vue";

const SettingsAPI = "https://ams4you.net/amsapi/public/websearch/GetWidgetSettings";
import axios from "axios";

export default {
    components: {
        TTabContainer,
        VTabContainer,
        HTabContainer,
        SidebarContainer,
        ModalContainer,
        ChatContainer,
        ScreenContainer,
        MascotContainer,
        CELContainer,
        OHLAContainer,
        DirastiContainer,
        AlterContainer,
        ILACContainer,
        ConexusContainer,
    },
    props: {
        ag: {
            type: Number,
            default: 0,
        },
        wid: {
            type: Number,
            default: 0,
        },
    },
    name: "App",
    data() {
        return {
            RulesLoaded: false,
            Translation: {},
            Settings: {},
        };
    },
    computed: {
        Colors() {
            let bgColor = this.Settings?.HeaderBackgroundColor;
            let textColor = this.Settings?.HeaderTextColor;
            return "--bg-color: " + bgColor + " !important; --text-color: " + textColor + " !important;";
        },
    },
    methods: {
        async GetRules() {
            this.RulesLoaded = false;
            let Query = "?ag=" + this.ag + "&wfid=" + this.wid;
            const request = await axios.get(SettingsAPI + Query);
            const response = request.data;
            if (response?.Settings && response?.Translation) {
                this.Settings = response.Settings;
                this.Translation = response.Translation;
            }
            this.RulesLoaded = true;
        },
    },
    mounted() {
        this.GetRules();
        let style = document.createElement("style");
        style.innerHTML = `
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700;900&display=swap');
        ams-search {
            font-family: "Poppins",sans-serif !important;
        }
        `;
        let widgets = document.body.querySelectorAll("ams-search");
        widgets.forEach((widget) => {
            document.body.appendChild(style);
        });
    },
    created() {},
};
</script>
<template>
    <div
        v-if="RulesLoaded"
        id="apsisx"
        :style="'--bg-color:' + this.Settings?.HeaderBackgroundColor + '; --text-color: ' + this.Settings?.HeaderTextColor + '; --main-color: ' + this.Settings?.MainColor"
        :dir="this.Settings?.LanguageName == 'Arabic' ? 'rtl' : 'ltr'"
    >
        <template v-if="ag == 256 && (wid == 94 || wid == 95)">
            <ScreenContainer v-if="wid == 95" />
            <MascotContainer v-if="wid == 94" />
        </template>
        <template v-else-if="ag == 13897 && wid == 96">
            <CELContainer />
        </template>
        <template v-else-if="ag == 963 && wid == 132">
            <OHLAContainer />
        </template>
        <template v-else-if="ag == 12496 && wid == 118">
            <ConexusContainer />
        </template>
        <template v-else-if="ag == 12496 && wid == 100">
            <DirastiContainer />
        </template>
        <template v-else-if="ag == 256 && wid == 99">
            <AlterContainer />
        </template>
        <template v-else-if="ag == 963 && wid == 109">
            <ILACContainer />
        </template>
        <template v-else>
            <HTabContainer v-if="Settings.Theme == 2" />
            <VTabContainer v-if="Settings.Theme == 1" />
            <TTabContainer v-if="Settings.Theme == 3" />
            <SidebarContainer v-if="Settings.Theme == 4" />
            <ModalContainer v-if="Settings.Theme == 5" />
            <ChatContainer v-if="Settings.Theme == 6" />
        </template>
    </div>
</template>
